import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/fonts.css';
import './tailwind-essentials.css'; // Importando classes CSS essenciais para builds de produção
import './styles/table-fixes.css'; // Importando correções para tabelas responsivas
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from 'react-router-dom';

// Configuração do Cognito OIDC
const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_gnHkEKwDt",
  client_id: "1m01p52tij9vis42i8jjjdji09",
  redirect_uri: window.location.origin + "/callback",
  post_logout_redirect_uri: window.location.origin + "/login",
  response_type: "code",
  scope: "email https://api.cerdata.co/all openid phone profile",
  // Configurações adicionais para melhor experiência
  automaticSilentRenew: true,
  loadUserInfo: true,
  monitorSession: true,
  onSigninCallback: () => {
    // Não fazer nada - deixa o componente de callback cuidar do redirecionamento
  },
  onSignoutCallback: () => {
    // Callback vazio pois o post_logout_redirect_uri já vai cuidar do redirecionamento
  },
  revokeTokensOnSignout: true,
  metadata: {
    issuer: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_gnHkEKwDt",
    authorization_endpoint: "https://auth.cerdata.co/oauth2/authorize",
    token_endpoint: "https://auth.cerdata.co/oauth2/token",
    userinfo_endpoint: "https://auth.cerdata.co/oauth2/userInfo",
    end_session_endpoint: "https://auth.cerdata.co/logout"
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
